<template>
  <div class="modal-chat">
    <!-- ヘッダー -->
    <header class="-header">
      <p>
        <span class="mdi mdi-comment-processing-outline -right-8px"></span>
        チャット画面<br>
        <span class="desc">{{selectChatRoom.name}}</span>
      </p>
      <button class="button close" @click="cancel()">
        <span class="mdi mdi-close"></span>
      </button>
    </header>
    <div class="-body" v-if="isVOC">
      <div
        class="chat-area"
        :class="{'my': chat.user === user.userHash}"
        v-for="(chat, i) in chatMessages" :key="i"
        :id="'scrollto-' + i">
        <div class="info">
          <p class="-name">{{chat.user_name}}</p>
        </div>
        <div class="main">
          <p class="-message">{{chat.message}}</p>
          <p class="-date">{{getTime(new Date(chat.created_at))}}</p>
        </div>
      </div>
    </div>
    <div class="-body" v-else>
      <span class="mdi mdi-loading mdi-spin"></span>
    </div>
    <div class="-footer">
      <textarea class="-chat" placeholder="ここに入力（500文字まで）" maxlength="500" v-model="message"/>
      <button class="button -btn" @click="sendMessage(message)">
        <span class="mdi mdi-send" style="color: #313E4D;"></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isVOC: {
      type: Boolean,
      required: true
    },
    uriChat: {
      type: String,
      required: true
    },
    chatMessages: {
      type: Array,
      required: true
    },
    selectChatRoom: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      message: null,
      files: []
    }
  },
  watch: {
    chatMessages () {
      if (this.chatMessages.length > 0) {
        this.$nextTick(() => {this.scrollDown(this.chatMessages.length - 1)})
        // this.$emit('unReadChange', {
        //   index: this.chatMessages.length - 1,
        //   count: 0,
        //   date: new Date()
        // })
      }
    },
  },
  created () {
    const uri = process.env.WS_ENDPOINT + 'vo/room/' + this.user.companyID + '/' + this.selectChatRoom.id + '/' + this.user.userHash
    if (this.uriChat != uri) {
      this.$store.dispatch('virtualOffice/connectChatRoomSV', uri)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.scrollDown(this.chatMessages.length - 1)
      // this.$emit('unReadChange', {
      //   index: this.chatMessages.length - 1,
      //   count: 0,
      //   date: new Date()
      // })
    })
  },
  methods: {
    cancel () {
      this.$emit('cancel', false, null)
    },
    sendMessage (message) {
      if (message != null) {
        this.$emit('sendMessage', {
          message: message
        })
        this.message = null
      } else {
        alert('1文字以上入力をお願い致します。')
      }
    },
    getTime (time) {
      return ('00' + time.getHours()).slice(-2) + ':' + ('00' + time.getMinutes()).slice(-2)
    },
    scrollDown (index) {
      let scrollLine = document.getElementById('scrollto-' + index)
      if (scrollLine) {
        if (this.chatMessages.length > 5) {
          scrollLine.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-chat {
  position: absolute;
  width: 320px;
  height: 100%;
  background: white;
  border-right: solid thin #ccc;
  top: 0;
  left: 200px;
  z-index: 2;
}
.-header {
  width: 100%;
  text-align: left;
  padding: 16px;
  font-weight: 600;
  font-size: 16px;
  height: 64px;
  display: flex;
  justify-content: space-between;
  border-bottom: solid thin #ccc;
  align-items: center;
  .desc {
    font-size: 11px;
    font-weight: 500;
  }
  .close {
    border: none;
    resize: none;
    outline:none;
    padding: 0;
    font-size: 18px;
  }
}
.-body {
  width: 100%;
  height: calc(100% - 128px);
  overflow-y: scroll;
  .my {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    /deep/ .-message {
      background: lightcyan !important;
      color: #2c3e50 !important;
    }
  }
  .chat-area {
    width: 100%;
    padding: 16px;
    text-align: left;
    margin-bottom: 8px;
    .info {
      .-name {
        font-size: 14px;
        font-weight: 600;
      }
    }
    .main {
      .-message {
        width: fit-content;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
        padding: 16px;
        font-size: 14px;
        margin-top: 8px;
        margin-bottom: 4px;
        color: white;
        background: #EE2C98;
        border-radius: 8px;
        word-break: break-word;
        white-space: pre-wrap;
      }
      .-date {
        margin-left: 8px;
        font-size: 11px;
        color: #666;
      }
    }
  }
}
.-footer {
  border-top: solid thin #ccc;
  height: 64px;
  width: 100%;
  display: flex;
  .-chat {
    min-width: calc(100% - 32px);
    width: calc(100% - 32px);
    min-height: 100%;
    height: 100%;
    padding: 8px;
    background: rgba(255,255,255,0.1);
    border: none;
    resize: none;
    outline:none;
  }
  .-btn {
    width: 32px;
    height: 32px;
    border: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/VirtualOffice/organisms/ChatRoom.vue